import { createContext, useContext, ReactNode, useMemo } from 'react';

type ImageItem = {
  url: string;
  label?: string;
  type?: 'image' | 'video';
};

interface MessageImagesContextType {
  images: ImageItem[];
}

const MessageImagesContext = createContext<MessageImagesContextType>({
  images: [],
});

const useMessageImages = () => useContext(MessageImagesContext);

interface MessageImagesProviderProps {
  images: ImageItem[];
  children: ReactNode;
}

function MessageImagesProvider({ images, children }: MessageImagesProviderProps) {
  const value = useMemo(() => ({ images }), [images]);

  return <MessageImagesContext.Provider value={value}>{children}</MessageImagesContext.Provider>;
}

export { MessageImagesProvider, useMessageImages };
export type { ImageItem };
